export const SYNC_CONNECT_ERROR = "sync_connect_error";
export const SYNC_DATA = "sync_data";
